/**
 * Premium global scroll reveal animation observer.
 * Uses a single IntersectionObserver for high performance (60fps).
 */
(function() {
  'use strict';

  function initScrollReveal() {
    const observerOptions = {
      threshold: 0.05,
      rootMargin: '0px 0px -40px 0px'
    };

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;

          if (target.classList.contains('reveal-group')) {
            // Stagger reveal of all child items
            const items = target.querySelectorAll('.reveal-item');
            const staggerMs = parseInt(target.getAttribute('data-stagger-delay')) || 100;
            
            items.forEach((item, index) => {
              const delay = item.getAttribute('data-reveal-delay') || (index * staggerMs) + 'ms';
              item.style.transitionDelay = delay;
              item.classList.add('is-revealed');
            });
          } else {
            // Reveal individual item
            target.classList.add('is-revealed');
          }

          // Stop observing once animation triggers
          observer.unobserve(target);
        }
      });
    }, observerOptions);

    // Query and observe target elements
    // We observe all .reveal-group elements and .reveal-item elements that are NOT inside a .reveal-group
    const elementsToObserve = document.querySelectorAll('.reveal-group, .reveal-item:not(.reveal-group .reveal-item)');
    elementsToObserve.forEach(el => {
      revealObserver.observe(el);
    });
    
    // Save observer instance on window to allow manual re-triggering if needed
    window.revealObserver = revealObserver;
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Support Shopify Theme Editor live-reload events
  document.addEventListener('shopify:section:load', function(e) {
    if (window.revealObserver) {
      const section = e.target;
      const elements = section.querySelectorAll('.reveal-group, .reveal-item:not(.reveal-group .reveal-item)');
      elements.forEach(el => {
        window.revealObserver.observe(el);
      });
    } else {
      initScrollReveal();
    }
  });
})();
